import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/inbox')({

}).lazy(() => import('./inbox.lazy').then((d) => d.Route));
